export default {
  computed: {
    extensionUrl() {
      return this.$i18n.locale !== 'zh' &&
        this.$i18n.locale !== 'zh-tw' &&
        this.$i18n.locale !== 'en'
        ? `https://extension.tokenpocket.pro/locale=en#/`
        : `https://extension.tokenpocket.pro/locale=${this.$i18n.locale}#/`;
    },
  },
};
